// extracted by mini-css-extract-plugin
export default {"container":"Qi-z","blurb":"Ri-z","links":"Si-z"};